import React from "react"

import { HeaderCycleNavigation } from "./HeaderCycleNavigation"

interface DetailPageNavigationProps {
  currentIndex: number | null
  hasNext: boolean
  hasPrevious: boolean
  itemLabel: string
  onNext: () => void
  onPrevious: () => void
  totalItems: number
}

export const DetailPageNavigation: React.FC<DetailPageNavigationProps> = ({
  currentIndex,
  hasNext,
  hasPrevious,
  itemLabel,
  onNext,
  onPrevious,
  totalItems,
}) => {
  const titleCaseLabel = itemLabel.charAt(0).toUpperCase() + itemLabel.slice(1)

  return (
    <HeaderCycleNavigation
      displayIndex={currentIndex}
      hasNext={hasNext}
      hasPrevious={hasPrevious}
      navAriaLabel={`${titleCaseLabel} navigation`}
      nextAriaLabel={`Next ${itemLabel}`}
      onNext={onNext}
      onPrevious={onPrevious}
      previousAriaLabel={`Previous ${itemLabel}`}
      totalItems={totalItems}
    />
  )
}
